import React, { useState } from 'react';
import { AutoComplete, Input } from 'antd';

export default function InputEmail({ email, handleSelect, setEmail, inputId }) {
  const [selectedDomain, setSelectedDomain] = useState('');
  const [options, setOptions] = useState([]);
  const handleEmailChange = (value) => {
    setSelectedDomain(value);
    setOptions([]);
  };

  const domains = [
    '@gmail.com',
    '@yahoo.com',
    '@hotmail.com',
    '@live.com',
    '@outlook.com',
  ];

  const handleSearch = (value) => {
    const domainIndex = value.lastIndexOf('@'); // Last position of "@" in the string
    if (domainIndex !== -1) {
      const username = value.substring(0, domainIndex); // Part before "@"
      const domain = value.substring(domainIndex); // Part after "@"
      const filteredOptions = domains.filter(
        (d) => d.indexOf(domain) !== -1 // Filter domains that contain the part after "@"
      );
      if (filteredOptions.length > 0) {
        setOptions(
          filteredOptions.map((d) => username + d) // Combine username with filtered domains
        );
      } else {
        setOptions([]);
      }
    } else {
      setOptions([]);
    }
  };

  return (
    <AutoComplete
      value={email}
      onChange={handleEmailChange}
      options={options.map((domain) => ({ value: domain }))}
      onSelect={handleSelect}
      onSearch={handleSearch}
      placeholder="Enter your email"
      className="w-full md:w-64"
    >
      <Input
        type="email"
        className="rounded-md w-full md:w-64"
        inputMode="email"
        id={inputId}
        onChange={(e) => setEmail(e.target.value)}
        value={email}
        allowClear
      />
    </AutoComplete>
  );
}
